import envConfig from '../config';

export const getCookie = (name: string): string => {
  let key = name;

  if (envConfig.ENV === 'stg') {
    key = `stg-${name}`;
  }

  const nameLenPlus = key.length + 1;

  return (
    document.cookie
      .split(';')
      .map((c) => c.trim())
      .filter((cookie) => {
        return cookie.substring(0, nameLenPlus) === `${key}=`;
      })
      .map((cookie) => {
        return decodeURIComponent(cookie.substring(nameLenPlus));
      })[0] || ''
  );
};

export const setCookie = (name: string, value: string, expires = '86400'): void => {
  let key = name;

  if (envConfig.ENV === 'stg') {
    key = `stg-${name}`;
  }

  const maxAge = expires ? `;max-age=${expires}` : '';

  document.cookie = `${key}=${value};path=/;domain=${envConfig.COOKIE_DOMAIN}${maxAge}`;
};

export const removeCookie = (name: string): void => {
  let key = name;

  if (envConfig.ENV === 'stg') {
    key = `stg-${name}`;
  }

  document.cookie = `${key}=;Max-Age=0;path=/;domain=${envConfig.COOKIE_DOMAIN}`;
};

export const removeAllCookies = (): void => {
  document.cookie.split(';').forEach((c) => {
    let name = c.split('=')?.[0]?.trim();

    if (envConfig.ENV === 'stg') {
      name = name.replace('stg-', '');
    }

    removeCookie(name);
  });
};
